import {createContext} from 'react';

export const NewBusinessCtx = createContext();
export const ClientsCtx = createContext();
export const PolicyStatementCtx = createContext();
export const ServiceRecordCtx = createContext();
